"use strict";

var _classCallCheck = require("/home/vsts/work/1/s/platform/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/vsts/work/1/s/platform/node_modules/@babel/runtime/helpers/createClass.js");
require("core-js/modules/es.array.sort.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var coreutils_1 = require("@jupyterlab/coreutils");
var apputils_1 = require("@jupyterlab/apputils");
var coreutils_2 = require("@phosphor/coreutils");
var mimemodel_1 = require("./mimemodel");
/* tslint:disable */
/**
 * The rendermime token.
 */
exports.IRenderMimeRegistry = new coreutils_2.Token('@jupyterlab/rendermime:IRenderMimeRegistry');
/* tslint:enable */
/* tslint:disable */
/**
 * The latex typesetter token.
 */
exports.ILatexTypesetter = new coreutils_2.Token('@jupyterlab/rendermime:ILatexTypesetter');
/* tslint:enable */
/**
 * An object which manages mime renderer factories.
 *
 * This object is used to render mime models using registered mime
 * renderers, selecting the preferred mime renderer to render the
 * model into a widget.
 *
 * #### Notes
 * This class is not intended to be subclassed.
 */
var RenderMimeRegistry = /*#__PURE__*/function () {
  /**
   * Construct a new rendermime.
   *
   * @param options - The options for initializing the instance.
   */
  function RenderMimeRegistry() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, RenderMimeRegistry);
    this._id = 0;
    this._ranks = {};
    this._types = null;
    this._factories = {};
    // Parse the options.
    this.resolver = options.resolver || null;
    this.linkHandler = options.linkHandler || null;
    this.latexTypesetter = options.latexTypesetter || null;
    this.sanitizer = options.sanitizer || apputils_1.defaultSanitizer;
    // Add the initial factories.
    if (options.initialFactories) {
      var _iterator = _createForOfIteratorHelper(options.initialFactories),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var factory = _step.value;
          this.addFactory(factory);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  /**
   * The ordered list of mimeTypes.
   */
  _createClass(RenderMimeRegistry, [{
    key: "mimeTypes",
    get: function get() {
      return this._types || (this._types = Private.sortedTypes(this._ranks));
    }
    /**
     * Find the preferred mime type for a mime bundle.
     *
     * @param bundle - The bundle of mime data.
     *
     * @param safe - How to consider safe/unsafe factories. If 'ensure',
     *   it will only consider safe factories. If 'any', any factory will be
     *   considered. If 'prefer', unsafe factories will be considered, but
     *   only after the safe options have been exhausted.
     *
     * @returns The preferred mime type from the available factories,
     *   or `undefined` if the mime type cannot be rendered.
     */
  }, {
    key: "preferredMimeType",
    value: function preferredMimeType(bundle) {
      var safe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ensure';
      // Try to find a safe factory first, if preferred.
      if (safe === 'ensure' || safe === 'prefer') {
        var _iterator2 = _createForOfIteratorHelper(this.mimeTypes),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var mt = _step2.value;
            if (mt in bundle && this._factories[mt].safe) {
              return mt;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      if (safe !== 'ensure') {
        // Otherwise, search for the best factory among all factories.
        var _iterator3 = _createForOfIteratorHelper(this.mimeTypes),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _mt = _step3.value;
            if (_mt in bundle) {
              return _mt;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      // Otherwise, no matching mime type exists.
      return undefined;
    }
    /**
     * Create a renderer for a mime type.
     *
     * @param mimeType - The mime type of interest.
     *
     * @returns A new renderer for the given mime type.
     *
     * @throws An error if no factory exists for the mime type.
     */
  }, {
    key: "createRenderer",
    value: function createRenderer(mimeType) {
      // Throw an error if no factory exists for the mime type.
      if (!(mimeType in this._factories)) {
        throw new Error("No factory for mime type: '".concat(mimeType, "'"));
      }
      // Invoke the best factory for the given mime type.
      return this._factories[mimeType].createRenderer({
        mimeType: mimeType,
        resolver: this.resolver,
        sanitizer: this.sanitizer,
        linkHandler: this.linkHandler,
        latexTypesetter: this.latexTypesetter
      });
    }
    /**
     * Create a new mime model.  This is a convenience method.
     *
     * @options - The options used to create the model.
     *
     * @returns A new mime model.
     */
  }, {
    key: "createModel",
    value: function createModel() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new mimemodel_1.MimeModel(options);
    }
    /**
     * Create a clone of this rendermime instance.
     *
     * @param options - The options for configuring the clone.
     *
     * @returns A new independent clone of the rendermime.
     */
  }, {
    key: "clone",
    value: function clone() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // Create the clone.
      var clone = new RenderMimeRegistry({
        resolver: options.resolver || this.resolver || undefined,
        sanitizer: options.sanitizer || this.sanitizer || undefined,
        linkHandler: options.linkHandler || this.linkHandler || undefined,
        latexTypesetter: options.latexTypesetter || this.latexTypesetter
      });
      // Clone the internal state.
      clone._factories = Object.assign({}, this._factories);
      clone._ranks = Object.assign({}, this._ranks);
      clone._id = this._id;
      // Return the cloned object.
      return clone;
    }
    /**
     * Get the renderer factory registered for a mime type.
     *
     * @param mimeType - The mime type of interest.
     *
     * @returns The factory for the mime type, or `undefined`.
     */
  }, {
    key: "getFactory",
    value: function getFactory(mimeType) {
      return this._factories[mimeType];
    }
    /**
     * Add a renderer factory to the rendermime.
     *
     * @param factory - The renderer factory of interest.
     *
     * @param rank - The rank of the renderer. A lower rank indicates
     *   a higher priority for rendering. If not given, the rank will
     *   defer to the `defaultRank` of the factory.  If no `defaultRank`
     *   is given, it will default to 100.
     *
     * #### Notes
     * The renderer will replace an existing renderer for the given
     * mimeType.
     */
  }, {
    key: "addFactory",
    value: function addFactory(factory, rank) {
      if (rank === undefined) {
        rank = factory.defaultRank;
        if (rank === undefined) {
          rank = 100;
        }
      }
      var _iterator4 = _createForOfIteratorHelper(factory.mimeTypes),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var mt = _step4.value;
          this._factories[mt] = factory;
          this._ranks[mt] = {
            rank: rank,
            id: this._id++
          };
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this._types = null;
    }
    /**
     * Remove a mime type.
     *
     * @param mimeType - The mime type of interest.
     */
  }, {
    key: "removeMimeType",
    value: function removeMimeType(mimeType) {
      delete this._factories[mimeType];
      delete this._ranks[mimeType];
      this._types = null;
    }
    /**
     * Get the rank for a given mime type.
     *
     * @param mimeType - The mime type of interest.
     *
     * @returns The rank of the mime type or undefined.
     */
  }, {
    key: "getRank",
    value: function getRank(mimeType) {
      var rank = this._ranks[mimeType];
      return rank && rank.rank;
    }
    /**
     * Set the rank of a given mime type.
     *
     * @param mimeType - The mime type of interest.
     *
     * @param rank - The new rank to assign.
     *
     * #### Notes
     * This is a no-op if the mime type is not registered.
     */
  }, {
    key: "setRank",
    value: function setRank(mimeType, rank) {
      if (!this._ranks[mimeType]) {
        return;
      }
      var id = this._id++;
      this._ranks[mimeType] = {
        rank: rank,
        id: id
      };
      this._types = null;
    }
  }]);
  return RenderMimeRegistry;
}();
exports.RenderMimeRegistry = RenderMimeRegistry;
/**
 * The namespace for `RenderMimeRegistry` class statics.
 */
(function (RenderMimeRegistry) {
  /**
   * A default resolver that uses a session and a contents manager.
   */
  var UrlResolver = /*#__PURE__*/function () {
    /**
     * Create a new url resolver for a console.
     */
    function UrlResolver(options) {
      _classCallCheck(this, UrlResolver);
      this._session = options.session;
      this._contents = options.contents;
    }
    /**
     * Resolve a relative url to an absolute url path.
     */
    _createClass(UrlResolver, [{
      key: "resolveUrl",
      value: function resolveUrl(url) {
        if (this.isLocal(url)) {
          var cwd = encodeURI(coreutils_1.PathExt.dirname(this._session.path));
          url = coreutils_1.PathExt.resolve(cwd, url);
        }
        return Promise.resolve(url);
      }
      /**
       * Get the download url of a given absolute url path.
       */
    }, {
      key: "getDownloadUrl",
      value: function getDownloadUrl(url) {
        if (this.isLocal(url)) {
          // decode url->path before passing to contents api
          return this._contents.getDownloadUrl(decodeURI(url));
        }
        return Promise.resolve(url);
      }
      /**
       * Whether the URL should be handled by the resolver
       * or not.
       *
       * #### Notes
       * This is similar to the `isLocal` check in `URLExt`,
       * but it also checks whether the path points to any
       * of the `IDrive`s that may be registered with the contents
       * manager.
       */
    }, {
      key: "isLocal",
      value: function isLocal(url) {
        var path = decodeURI(url);
        return coreutils_1.URLExt.isLocal(url) || !!this._contents.driveName(path);
      }
    }]);
    return UrlResolver;
  }();
  RenderMimeRegistry.UrlResolver = UrlResolver;
})(RenderMimeRegistry = exports.RenderMimeRegistry || (exports.RenderMimeRegistry = {}));
/**
 * The namespace for the module implementation details.
 */
var Private;
(function (Private) {
  /**
   * Get the mime types in the map, ordered by rank.
   */
  function sortedTypes(map) {
    return Object.keys(map).sort(function (a, b) {
      var p1 = map[a];
      var p2 = map[b];
      if (p1.rank !== p2.rank) {
        return p1.rank - p2.rank;
      }
      return p1.id - p2.id;
    });
  }
  Private.sortedTypes = sortedTypes;
})(Private || (Private = {}));